/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Provenance metadata for a data table, telling the user where the data came from, when it was last refreshed, and whether the latest ingest succeeded.
 */
export interface DataSource { 
    /**
     * Name of the system the data was sourced from, for example \'Snowflake\'.
     */
    provider: string;
    /**
     * ISO 8601 timestamp of the most recent successful data ingest.
     */
    lastIngested: string;
    /**
     * How often the source data is refreshed, for example \'daily\' or \'hourly\'.
     */
    cadence: string;
    /**
     * Health of the most recent ingest. \'success\' means fresh and complete, \'warning\' means stale or partial, \'error\' means the ingest failed.
     */
    status: DataSource.StatusEnum;
}
export namespace DataSource {
    export const StatusEnum = {
        Success: 'success',
        Warning: 'warning',
        Error: 'error'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


